import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AuthenticationProvider } from "./auth/AuthContext";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Application root is missing.");

createRoot(root).render(
  <StrictMode>
    <AuthenticationProvider>
      <App />
    </AuthenticationProvider>
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    const revision =
      document.querySelector<HTMLScriptElement>('script[type="module"]')?.src ??
      "shell";
    void navigator.serviceWorker
      .register(`/sw.js?revision=${encodeURIComponent(revision)}`)
      .then((registration) => {
        registration.addEventListener("updatefound", () => {
          if (registration.active)
            window.dispatchEvent(new Event("pc:shell-update"));
        });
      });
  });
}
